import * as React from 'react';
import injectSheet from 'react-jss';
import { Button } from 'antd';
import AirplaneIcon from 'src/components/common/icons/AirplaneIcon'

const styles = theme => ({
    selected: {
        borderColor: '#1890FF',
        color: '#1890FF',
    },
    unselected: {
        borderColor: '#D9D9D9',
        color: '#D9D9D9',
    }
});

const SEAwb = ({
    classes,
    awb,
    selected = true,
    onClick = e => {},
    nonClickable = false,
  }) => {

    return <Button
      className={`${selected ? classes.selected : classes.unselected}`}
      style={{
        width: 'fit-content',
        background: 'transparent',
        pointerEvents: nonClickable ? 'none' : 'auto',
      }}
      onClick={onClick}>
      <>
        <AirplaneIcon color={`${selected ? '#1890FF' : '#D9D9D9'}`}/>
        <span style={{ marginLeft: 5 }}>{awb}</span>
      </>
    </Button>;
  };

  export default React.memo(
    injectSheet(styles)(SEAwb),
  );